import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import WorkInProgress from "./WorkInProgress";
import Footer from "../../core/common/Footer";
import useApi from "../../core/customhook/useApi";
import webservice_url from "../../core/webservice/Webservice_url";
import { all_routes } from "../router/all_routes"; // adjust path if different
import "./TrackCaseProgram.css";

interface CountData {
  key: string;
  status_id: string;
  label: string;
  count: number;
}
 
const CaseMark = () => (
  <svg className="tcp-case-mark" viewBox="0 0 40 32" aria-hidden="true" focusable="false">
    <rect x="0" y="14" width="4" height="18" rx="1.5" />
    <rect x="9" y="8" width="4" height="24" rx="1.5" />
    <rect x="18" y="0" width="4" height="32" rx="1.5" />
    <rect x="27" y="10" width="4" height="22" rx="1.5" />
    <rect x="36" y="18" width="4" height="14" rx="1.5" />
  </svg>
);

const TrackCaseProgram = () => {
  const [data, setData] = useState<CountData[]>([]);
  const navigate = useNavigate();

  const activeTab = "workInProgress";

  const getTotalCounts = useApi<any>(webservice_url.getTotalCountsGlobal, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const fetchData = async () => {
    try {
      const res = await getTotalCounts.callApi({});
      setData(res?.data ?? []);
    } catch (err) {
      console.error(err);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getCount = (key: string) =>
    data.find((item) => item.key === key)?.count ?? 0;

  const getStatusId = (key: string) =>
    data.find((item) => item.key === key)?.status_id ?? "";

  const tabs = useMemo(
    () => [
      {
        id: "workInProgress",
        label: "Work In Progress",
        count: getCount("WORK_IN_PROGRESS"),
        component: (
          <WorkInProgress statusId={getStatusId("WORK_IN_PROGRESS")} />
        ),
      },
    ],
    [data],
  );

  const handleBulkDrugReportRedirect = () => {
    navigate(all_routes.drugReport);
  };

  return (
    <div className="page-wrapper tcp-page">
      <div className="content p-2 p-md-3">
        {/* ---------------- Page header ---------------- */}
        <div className="tcp-header">
          <div className="tcp-header-title-row">
            <CaseMark />
            <div>
              <h4 className="tcp-title">Live Case Progress</h4>
              <p className="tcp-subtitle">
                Track active cases, monitor check status, and manage
              in-progress screening work from one workspace.
              </p>
            </div>
          </div>

          <button
            type="button"
            className="tcp-btn tcp-btn-primary"
            onClick={handleBulkDrugReportRedirect}
          >
            <i className="ti ti-upload"></i>
            <span className="tcp-btn-label">Add Bulk Drug Report</span>
          </button>
        </div>

        {/* ---------------- Status tabs ---------------- */}
        {/* <ul className="tcp-tabs">
          {tabs.map((tab) => (
            <li key={tab.id}>
              <button
                type="button"
                className={`tcp-tab ${activeTab === tab.id ? "tcp-tab-active" : ""}`}
                onClick={() => {}}
              >
                <span className="tcp-tab-label">{tab.label}</span>
                {typeof tab.count === "number" && (
                  <span className="tcp-tab-count">{tab.count}</span>
                )}
              </button>
            </li>
          ))}
        </ul> */}

        <div className="tcp-tab-content">
          {tabs.find((tab) => tab.id === activeTab)?.component}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TrackCaseProgram;


// import { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router";
// import WorkInProgress from "./WorkInProgress";
// import Footer from "../../core/common/Footer";
// import useApi from "../../core/customhook/useApi";
// import webservice_url from "../../core/webservice/Webservice_url";
// import { all_routes } from "../router/all_routes"; // adjust path if different

// interface CountData {
//   key: string;
//   status_id: string;
//   label: string;
//   count: number;
// }

// const TrackCaseProgram = () => {
//   const [data, setData] = useState<CountData[]>([]);
//   const navigate = useNavigate();

//   const activeTab = "workInProgress";

//   const getTotalCounts = useApi<any>(webservice_url.getTotalCountsGlobal, {
//     method: "POST",
//     autoCall: false,
//     handleGlobalError: false,
//   });

//   const fetchData = async () => {
//     try {
//       const res = await getTotalCounts.callApi({});
//       setData(res?.data ?? []);
//     } catch (err) {
//       console.error(err);
//       setData([]);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const getCount = (key: string) =>
//     data.find((item) => item.key === key)?.count ?? 0;

//   const getStatusId = (key: string) =>
//     data.find((item) => item.key === key)?.status_id ?? "";

//   const tabs = useMemo(
//     () => [
//       {
//         id: "workInProgress",
//         label: "Work In Progress",
//         count: getCount("WORK_IN_PROGRESS"),
//         component: (
//           <WorkInProgress statusId={getStatusId("WORK_IN_PROGRESS")} />
//         ),
//       },
//     ],
//     [data],
//   );

//   const handleBulkDrugReportRedirect = () => {
//     navigate(all_routes.drugReport); 
//   };

//   return (
//     <div className="page-wrapper">
//       <div className="content p-2 p-md-3">
//         <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
//           <ul className="invite-tabs mb-0">
//             {tabs.map((tab) => (
//               <li key={tab.id}>
//                 <button
//                   type="button"
//                   className={`invite-btn ${activeTab === tab.id ? "active" : ""}`}
//                   onClick={() => {}}
//                 >
//                   <span className="d-block">{tab.label}</span>
//                   {typeof tab.count === "number" && (
//                     <span className="d-block fw-semibold">{tab.count}</span>
//                   )}
//                 </button>
//               </li>
//             ))}
//           </ul>

//           <button
//             type="button"
//             className="btn btn-primary d-flex align-items-center gap-2"
//             onClick={handleBulkDrugReportRedirect}
//           >
//             <i className="ti ti-upload"></i>
//             Add Bulk Drug Report
//           </button>
//         </div>

//         <div className="mt-3">
//           {tabs.find((tab) => tab.id === activeTab)?.component}
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default TrackCaseProgram;

// import { useEffect, useMemo, useState } from "react";
// import WorkInProgress from "./WorkInProgress";
// import Footer from "../../core/common/Footer";
// import useApi from "../../core/customhook/useApi";
// import webservice_url from "../../core/webservice/Webservice_url";

// interface CountData {
//   key: string;
//   status_id: string;
//   label: string;
//   count: number;
// }

// const TrackCaseProgram = () => {
//   const [data, setData] = useState<CountData[]>([]);

//   const activeTab = "workInProgress";

//   const getTotalCounts = useApi<any>(webservice_url.getTotalCountsGlobal, {
//     method: "POST",
//     autoCall: false,
//     handleGlobalError: false,
//   });

//   const fetchData = async () => {
//     try {
//       const res = await getTotalCounts.callApi({});
//       setData(res?.data ?? []);
//     } catch (err) {
//       console.error(err);
//       setData([]);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const getCount = (key: string) =>
//     data.find((item) => item.key === key)?.count ?? 0;

//   const getStatusId = (key: string) =>
//     data.find((item) => item.key === key)?.status_id ?? "";

//   const tabs = useMemo(
//     () => [
//       {
//         id: "workInProgress",
//         label: "Work In Progress",
//         count: getCount("WORK_IN_PROGRESS"),
//         component: (
//           <WorkInProgress statusId={getStatusId("WORK_IN_PROGRESS")} />
//         ),
//       },
//     ],
//     [data],
//   );

//   return (
//     <div className="page-wrapper">
//       <div className="content p-2 p-md-3">
//         {/* <TabItems
//           tabList={tabs}
//           activeTab={activeTab}
//           handleClick={(d) => {
//             setActiveTab(d.id);
//             localStorage.setItem("active-track-case-tab", d.id);
//           }}
//         /> */}
//         <ul className="invite-tabs">
//           {tabs.map((tab) => (
//             <li key={tab.id}>
//               <button
//                 type="button"
//                 className={`invite-btn ${activeTab === tab.id ? "active" : ""}`}
//                 onClick={() => {}}
//               >
//                 <span className="d-block">{tab.label}</span>
//                 {typeof tab.count === "number" && (
//                   <span className="d-block fw-semibold">{tab.count}</span>
//                 )}
//               </button>
//             </li>
//           ))}
//         </ul>

//         <div className="mt-3">
//           {tabs.find((tab) => tab.id === activeTab)?.component}
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default TrackCaseProgram;
